var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.5 2L2 8.5M2 8.5L8.5 15M2 8.5H15.5","stroke":"currentColor","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }